import React, { useState, useEffect } from "react";
import { Tag, Space, Row, Col, Button, Checkbox, DatePicker, Input, Spin } from "antd";
import AppTable from "../../components/AppTable/AppTable";

import axiosGet from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";
import moment from "moment";
import "../../pages/Booking/Booking.scss";

const { Search } = Input;

const DriverDeatils = () => {
  const [currentBookingGridData, setCurrentBookingGridData] = useState([]);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [branchid, setbranchid]: any = useState(localStorage.getItem("cityid"));
  const [SearchText, setsearchText]: any = useState("");
  const [copycurrentBookingGridData, setcopyCurrentBookingGridData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ButtonClicked, setIsButtonClicked] = useState("Today");
  const [pagination, setPagination]:any = useState({
    current: 1,
    pageSize: 100,
  });
 
  const RangePicker = DatePicker.RangePicker;
  const columns = [
    {
        title: "Driver Id",
        dataIndex: "driver_id",
        key: "Booking ID",

    },
    {
        title: "Name",
        dataIndex: "driver_name",
        key: "Booking ID",

    },
    {
        title: "Mobile Number",
        dataIndex: "driver_mobno",
        key: "Name",

    },
    {
        title: "Adhar Number",
        dataIndex: "driveraadhar",
        key: "Name",

    },

    {
        title: "Driving License No",
        dataIndex: "driver_licenceno",
        key: "Name",

    },
    {
        title: "Badge No",
        dataIndex: "driverbadge",
        key: "Name",

    },
    {
        title: "Address",
        dataIndex: "driver_address",
        key: "Name",

    },
    {
        title: "D of joining",
        dataIndex: "name",
        key: "Name",

    },
    {
        title: "Truck Id",
        dataIndex: "cab_id",
        key: "Name",

    },
    {
        title: "Vehicle ID",
        dataIndex: "vehicleid",
        key: "Name",

    },
  



]

  const onChange=(dates:any, dateStrings:any)=> {
    try{
    console.log('From: ', dates[0], ', to: ', dates[1]);
    console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    let startdate = dateStrings[1];
    var new_date = moment(startdate, "YYYY-MM-DD").add('days', 1);
    var day = new_date.format('DD');
    var month = new_date.format('MM');
    var year = new_date.format('YYYY');
    let todate=year + '-' + month + '-' + day;
    DateSearch(/* dateStrings[0],todate, */pagination, SearchText);
    }
    catch(ex){
      console.log(ex);
    }
  };

  const adayclick =(event: any=null)=>{
    setIsButtonClicked('Today');
    var first = moment();
    var firstday = first.format('DD'); var firstmonth = first.format('MM'); var firstyear = first.format('YYYY');
    let fromdate=firstyear + '-' + firstmonth + '-' + firstday;
    var new_date = moment().add('days', 1);
    var day = new_date.format('DD'); var month = new_date.format('MM'); var year = new_date.format('YYYY');
    let todate=year + '-' + month + '-' + day;
    DateSearch(/* fromdate,todate, */pagination, SearchText);
  };

 



const DateSearch =(/* fromdate:any,todate:any, */pagination:any, SearchText:any)=>{
  setIsLoading(true);
  const options: any = {
    params: {
      branchid:branchid,
      limit: pagination.pageSize,
      skip: (pagination.current-1) * (pagination.pageSize),
      filtervalue: SearchText
    },
  };
  axiosGet(UrlConstants.getdriverdetails,options).then((resp: any) => {
    resp.data.forEach((e: any) => {
      e.key = e.id;
    });
    setIsLoading(false);
    setCurrentBookingGridData(resp.data);
    setcopyCurrentBookingGridData(resp.data);
    setPagination({
      ...pagination,
      total: resp.tablelength
    });
    console.log(resp);

  }).catch(function (error:any) {
    setIsLoading(false);
    if (error.response) {
      console.log(error.response.data,error.response.status);
      setCurrentBookingGridData([]);
      setcopyCurrentBookingGridData([]);
    }
  });
  };



  useEffect(() => {
    console.log(isRowSelected);
    adayclick();
  }, []);
  const onSearchchange = (e: any) => {
    console.log(e.target.value);
    setsearchText(e.target.value);
    globalSearch(e.target.value);
  };
    const globalSearch = (searchText:any) =>{ 
      console.log(currentBookingGridData);

    let filteredData = currentBookingGridData.filter((value: any) => {
      if(value.driver_id===undefined || value.driver_id===null)
        value.driver_id='';
      if(value.driver_name===undefined || value.driver_name===null)
        value.driver_name='';
      if(value.driver_mobno===undefined || value.driver_mobno===null)
        value.driver_mobno='';
      if(value.driveraadhar===undefined || value.driveraadhar===null)
        value.driveraadhar='';
      if(value.driver_licenceno===undefined || value.driver_licenceno===null)
        value.driver_licenceno='';
      if(value.driverbadge===undefined || value.driverbadge===null)
        value.driverbadge='';
      if(value.driver_address===undefined || value.driver_address===null)
        value.driver_address='';
      if(value.cab_id===undefined || value.cab_id===null)
        value.cab_id='';
      if(value.vehicleid===undefined || value.vehicleid===null)
        value.vehicleid='';

    return (
             value.driver_name.toString().toLowerCase().includes(searchText.toLowerCase()) ||
         value.cab_id.toString().toLowerCase().includes(searchText.toLowerCase()) ||
        value.driver_id
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase())||
          value.driver_mobno
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()) || 
           value.driveraadhar
           .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
          value.driver_licenceno
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
          value.driverbadge
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
          value.driver_address
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
          value.vehicleid
          .toString()
          .toLowerCase()
          .includes(searchText.toLowerCase()) 
      );
    });
      setcopyCurrentBookingGridData(filteredData);
};

function disabledDate(current:any) {
  // Can not select days before today and today
  return current > moment().endOf('day');
}
const onPaginationchange = (pagination:any, filters:any, sorter:any, extra:any) => {
  setPagination(pagination);
  DateSearch(/* fromdate, todate,  */pagination, SearchText);
  console.log(pagination); 
}
const onSearch = (value:any) => {
  console.log(value);
  setsearchText(value);
  DateSearch(/* fromdate, todate,  */pagination, value);
}

  return (
    <div className="booking-child-routes">
      <div className="booking-child-routes-button-section">
      <Row style={{paddingBottom:10}}>
        
              <Col span={4} offset={20}>
        {/* <Input  placeholder="Search Text" value={SearchText} onChange={onSearchchange}/> */}
        <Search placeholder="Search Text" onSearch={onSearch} enterButton/>
        </Col>
        </Row>
      </div>
      
      <div>
      <Spin tip="Loading..." spinning={isLoading}>
        <AppTable
          columns={columns}
          data={copycurrentBookingGridData}
          onchange={onPaginationchange}
          enablePagination={pagination}
          selectionType="radio"
          scroll={{ x:1800,y: 480 }}
        ></AppTable>
        </Spin>
      </div>
    </div>
  );
};

export default DriverDeatils;
